import _ from 'lodash';
var Constants = require('../constants/InvestmentAllocationConstants');

module.exports = {
    getInvestmentOptions: function (applicationData) {
        var investmentOptions = _.get(applicationData, 'form.investmentAllocation.investmentOptions');        
        if (!investmentOptions || investmentOptions.length <= 0) {
            return null;
        }

        var investmentOptionsList = [];
        _.forEach(applicationData.form.investmentAllocation.investmentOptions,
            function (n) {
                investmentOptionsList.push({
                    id: n.id,
                    code: n.code,
                    name: n.name,
                    weight: n.weight.toFixed(2),
                    originalWeight: n.originalWeight,
                    termDeposit: n.termDeposit,
                    isFirstRateInvestment: n.isFirstRateInvestment,
                    rebatePaymentOption: n.rebatePaymentOption,
                    groupSequenceNumber: n.groupSequenceNumber,
                    redemptionSequenceNumber: n.redemptionSequenceNumber,
                    isManagedAccountOrModelPortfolio: n.isManagedAccountOrModelPortfolio,
                    cashOption : n.termDeposit || n.id == Constants.FirstRateSaverNonAutoRebalancing || n.id == Constants.FirstRateCashNonAutoRebalancing|| n.id == Constants.FirstRateTTRSaverNonAutoRebalancing
                });
            });

        return investmentOptionsList;
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/InvestmentAllocationHelper.js